var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"manual-mode"},[_c('MultipleSelectSettingsEditor',{attrs:{"options":_vm.dropdownOptions,"isOptionValue":_vm.isOptionValue,"keyPlaceholder":"Enter dropdown option...","valuePlaceholder":"Enter dropdown value...","noSuffix":_vm.noSuffix},on:{"onChange":_vm.onChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }